import { useState } from 'react';
import { Select, MenuItem, Grid, Typography } from '@mui/material';
import { useCurrentCompanyList } from 'hooks/api/useCompanies';
import smallLogo from 'components/common/Icon/assets/formationsLogo.png';

export const BusinessSelector = ({
  userId,
  accountId,
  businessId,
  handleSwitchCompany,
}: {
  userId: string;
  accountId: string;
  businessId: string;
  handleSwitchCompany: (businessId: string) => void;
}) => {
  const { companies: userBusinesses } = useCurrentCompanyList(userId);

  const [openSelectBusiness, setOpenSelectBusiness] = useState(false);
  const handleOpenMenu = () => {
    setOpenSelectBusiness(true);
  };

  const handleCloseMenu = () => {
    setOpenSelectBusiness(false);
  };
  return (
    <Select
      labelId="filter-business"
      id="filterBusiness"
      name="filterBusiness"
      value={businessId}
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        width: '200px',
        backgroundColor: 'white',
      }}
      open={openSelectBusiness}
      onOpen={handleOpenMenu}
      onClose={handleCloseMenu}
      onChange={(e) => {
        if (e.target.value) {
          handleSwitchCompany(e.target.value);
        }
        handleCloseMenu();
      }}
      renderValue={(value) => {
        const business = userBusinesses.find((b) => b.id === value);
        if (!business) {
          return null;
        }
        return (
          <Grid
            container
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="center"
          >
            <img
              src={smallLogo}
              alt={business.name}
              width="24px"
              height="24px"
              style={{ marginRight: '8px' }}
            />
            <Typography
              variant="body1S"
              component="p"
              width="120px"
              maxWidth="120px"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {business.name || business.id}
            </Typography>
          </Grid>
        );
      }}
    >
      {userBusinesses.map((business) => (
        <MenuItem
          key={business.id}
          value={business.id}
          sx={{
            width: '200px',
          }}
        >
          <Grid
            container
            display="flex"
            alignItems="flex-start"
            flexDirection="row"
            width="168px"
          >
            <img
              src={smallLogo}
              alt={business.name}
              width="24px"
              height="24px"
              style={{ marginRight: '8px' }}
            />
            <Grid item width="136px" flexDirection="column">
              <Typography
                variant="body2B"
                component="p"
                width="136px"
                maxWidth="136px"
                overflow="hidden"
                textOverflow="ellipsis"
                marginBottom="4px"
              >
                {business.name || business.id}
              </Typography>
              <Typography
                variant="body3S"
                color="text.secondary"
                component="p"
                width="136px"
                maxWidth="136px"
                overflow="hidden"
                textOverflow="ellipsis"
              >
                {business.accountId === accountId ? 'Owner' : 'Member'}
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      ))}
      {/* <Grid container width="200px" p={2} justifyContent="center">
          <FormationsGhostButton
            startIcon={<AddIcon size={24} />}
            sx={{ width: '168px' }}
            onClick={displayAddBusinessModal}
          >
            New Business
          </FormationsGhostButton>
        </Grid> */}
    </Select>
  );
};
